module.exports = __webpack_public_path__ + "static/media/thumbnail.92ac8f44.jpg";